// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../styles/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading {
  color: #1e1e1e;
  font-weight: 500;
  font-size: 1.125rem;
}

.m-top {
  margin-top: 45px;
}

.slider {
  height: 17px;
  border-radius: 30px;
  background: rgba(212, 210, 255, 0.31);
  margin-top: 11px;
}

.inner-slider {
  border-radius: 30px;
  background: linear-gradient(0deg, #6c63ff 0%, #6c63ff 100%), #f1f1f1;
}

.inner-slider-w {
  height: 17px;
}

.antecedents-w {
  width: 9%;
}

.knowledge-w {
  width: 18%;
}

.generalSkills-w {
  width: 27%;
}

.confidence-w {
  width: 36%;
}

.attributes-w {
  width: 45%;
}

.qualifications-w {
  width: 54%;
}

.social-w {
  width: 63%;
}

.progression-w {
  width: 72%;
}

.global-w {
  width: 81%;
}

.clientObligations-w {
  width: 90%;
}

.adviserObligations-w {
  width: 100%;
}

.adviserFeedback-w {
  width: 84%;
}

.adviserImpact-w {
  width: 91%;
}

.overallExperience-w {
  width: 100%;
}

.questionnaire-heading-m {
  margin-top: 81px;
}

.questionnaire-heading {
  color: #1e1e1e;
  font-size: 24px;
}

.questionnaire-heading-content {
  color: #777;
  margin-top: 11px;
}

.set-line-height {
  line-height: normal;
}
`, "",{"version":3,"sources":["webpack://./src/components/molecules/jsQuestionnaireHeader/jsQuestionnaireHeader.css"],"names":[],"mappings":"AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oEAAoE;AACtE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["@import \"../../styles/global.css\";\n\n.heading {\n  color: #1e1e1e;\n  font-weight: 500;\n  font-size: 1.125rem;\n}\n\n.m-top {\n  margin-top: 45px;\n}\n\n.slider {\n  height: 17px;\n  border-radius: 30px;\n  background: rgba(212, 210, 255, 0.31);\n  margin-top: 11px;\n}\n\n.inner-slider {\n  border-radius: 30px;\n  background: linear-gradient(0deg, #6c63ff 0%, #6c63ff 100%), #f1f1f1;\n}\n\n.inner-slider-w {\n  height: 17px;\n}\n\n.antecedents-w {\n  width: 9%;\n}\n\n.knowledge-w {\n  width: 18%;\n}\n\n.generalSkills-w {\n  width: 27%;\n}\n\n.confidence-w {\n  width: 36%;\n}\n\n.attributes-w {\n  width: 45%;\n}\n\n.qualifications-w {\n  width: 54%;\n}\n\n.social-w {\n  width: 63%;\n}\n\n.progression-w {\n  width: 72%;\n}\n\n.global-w {\n  width: 81%;\n}\n\n.clientObligations-w {\n  width: 90%;\n}\n\n.adviserObligations-w {\n  width: 100%;\n}\n\n.adviserFeedback-w {\n  width: 84%;\n}\n\n.adviserImpact-w {\n  width: 91%;\n}\n\n.overallExperience-w {\n  width: 100%;\n}\n\n.questionnaire-heading-m {\n  margin-top: 81px;\n}\n\n.questionnaire-heading {\n  color: #1e1e1e;\n  font-size: 24px;\n}\n\n.questionnaire-heading-content {\n  color: #777;\n  margin-top: 11px;\n}\n\n.set-line-height {\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
